import React from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { handleLogout } from '../../../redux/slices/authSlice';

const EmployeDashboardSidebar = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate()
    const handleLogoutHere = async () => {
        const res = await dispatch(handleLogout())
        navigate("/signin");
    }

    return (
        <>
            <ul className="corporate-sidebar sidebar-space-control">
                <li>
                    <NavLink to="/employee/chat" className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-regular fa-comment"></i> Chat</NavLink>
                </li>

                <li>
                    <NavLink to="/employee/services" className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fas fa-users-cog"></i> My Services</NavLink>
                </li>

                <li>
                    <NavLink to="/employee/schedule" className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-calendar-days"></i> My Schedule</NavLink>
                </li>

                <li>
                    <NavLink to="/employee/profile" className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-regular fa-user"></i> My Profile</NavLink>
                </li>

                <li>
                    <NavLink to='/employee/feedbacks' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-star"></i> Rating & Reviews</NavLink>
                </li>

                {/* <li>
                    <NavLink to='/employee/subscriptions' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fas fa-crown"></i> Subscription</NavLink>
                </li> */}

                <li>
                    <NavLink to='/employee/settings' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fa-solid fa-gear"></i> Settings</NavLink>
                </li>

                <li>
                    <a onClick={handleLogoutHere} style={{ cursor: 'pointer' }}><i className="fa-solid fa-right-from-bracket"></i> Logout</a>
                </li>
            </ul>
        </>
    )
}

export default EmployeDashboardSidebar